/**
 * Converts the data URLs returned by `SimpleCamera` (`canvas.toDataURL`) into
 * JPEG `File` objects ready for upload.
 */
export const dataUrlsToFiles = (
  urls: string[],
  namePrefix: string
): Promise<File[]> =>
  Promise.all(
    urls.map(async (url, index) => {
      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to process photo");
      const blob = await res.blob();
      return new File([blob], `${namePrefix}-${Date.now()}-${index}.jpg`, {
        type: "image/jpeg",
      });
    })
  );
